module.exports = __webpack_public_path__ + "static/world-map-0f829cbe5e6b4ded92d1833b1f76704c.svg";